import Loading from "../../models/Loading";
import {RequestStatus} from "../../utils/Enums";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {apiClient} from "../../utils/ApiClient";
import {deleteCategory} from "./CategoriesSlice";

interface LoadingsState {
    loadings: Loading[],
    currentLoading: Loading | null,
    getCurrentLoadingStatus: RequestStatus;
    updateLoadingStatus: RequestStatus;
    deleteLoadingStatus: RequestStatus;
    errors: string[],
}

const initialState: LoadingsState = {
    loadings: [],
    currentLoading: null,
    getCurrentLoadingStatus: RequestStatus.Idle,
    updateLoadingStatus: RequestStatus.Idle,
    deleteLoadingStatus: RequestStatus.Idle,
    errors: []
}

export const getCurrentLoading = createAsyncThunk(
    'loadings/getCurrentLoading',
    async ({id}: { id: string | undefined }, {rejectWithValue}) => {
        const response = await apiClient.get(`loadings/${id}`);
        return response.data;
    }
);

export const updateLoading = createAsyncThunk(
    'loadings/updateLoading',
    async ({id, data}: { id: string | undefined, data: any }, {rejectWithValue}) => {
        const response = await apiClient.put(`loadings/${id}`, data);
        return response.data;
    }
);

export const deleteLoading = createAsyncThunk(
    'loadings/deleteLoading',
    async ({id}: { id: string | undefined }, {rejectWithValue}) => {
        const response = await apiClient.delete(`loadings/${id}`);
        return response.data;
    }
);

const loadingsSlice = createSlice({
    name: 'loadings',
    initialState,
    reducers: {
        resetUpdateLoadingStatus: (state) => {
            state.updateLoadingStatus = RequestStatus.Idle;
            state.currentLoading = null;
        },
        resetDeleteLoadingStatus: (state) => {
            state.deleteLoadingStatus = RequestStatus.Idle;
            state.currentLoading = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCurrentLoading.pending, (state, action) => {
                state.getCurrentLoadingStatus = RequestStatus.Loading;
            })
            .addCase(getCurrentLoading.fulfilled, (state, action) => {
                state.getCurrentLoadingStatus = RequestStatus.Success;
                state.currentLoading = action.payload;
            })
            .addCase(getCurrentLoading.rejected, (state, action) => {
                state.getCurrentLoadingStatus = RequestStatus.Failed;
            })

            .addCase(updateLoading.pending, (state, action) => {
                state.updateLoadingStatus = RequestStatus.Loading;
                state.errors = [];
            })
            .addCase(updateLoading.fulfilled, (state, action) => {
                state.updateLoadingStatus = RequestStatus.Success;
            })
            .addCase(updateLoading.rejected, (state, action) => {
                state.updateLoadingStatus = RequestStatus.Failed;
                const errors = JSON.parse(action?.error?.message ?? '{}');
                if (errors) {
                    state.errors = Array.isArray(errors.errors) ? errors.errors : [];
                } else {
                    state.errors = ['Tuvastamata viga.'];
                }
            })

            .addCase(deleteLoading.pending, (state, action) => {
                state.deleteLoadingStatus = RequestStatus.Loading;
            })
            .addCase(deleteLoading.fulfilled, (state, action) => {
                state.deleteLoadingStatus = RequestStatus.Success;
            })
            .addCase(deleteLoading.rejected, (state, action) => {
                state.deleteLoadingStatus = RequestStatus.Failed;
            });
    },
});

export const {
    resetUpdateLoadingStatus,
    resetDeleteLoadingStatus
} = loadingsSlice.actions;
export default loadingsSlice.reducer;